import styled from "styled-components";

export const FileGroup = styled("div")(({ theme }) => ({
  width: "100%",
}));

export const Label = styled("div")(({ theme }) => ({
  width: "100%",
  fontSize: 10,
  paddingLeft: 15,
  paddingTop: 2,
  color: theme.palette.input.labelText,

  [theme.down("sm")]: {
    fontSize: 9,
    paddingLeft: 12,
  },
}));

export const FileBlock = styled("label")(({ theme, isError }) => ({
  ...theme.mixins.flexAlignCenter,
  gap: 12,
  minHeight: 50,
  ...theme.paddings(6, 15, 8, 15),
  borderRadius: 4,
  border: `1px dashed ${isError ? theme.palette.input.borderError : theme.palette.input.border}`,
  ...(isError ? { backgroundColor: theme.palette.input.errorBg } : {}),
  cursor: "pointer",
  transition: "all .2s ease",

  "&:hover": {
    borderColor: theme.palette.input.borderFocus,
  },

  "& > input": {
    display: "none",
  },

  [theme.down("sm")]: {
    ...theme.paddings(6, 12, 8, 12),
  },
}));

export const ChooseButton = styled("span")(({ theme }) => ({
  ...theme.mixins.flexCenterCenter,
  flexShrink: 0,
  height: 34,
  ...theme.paddings(0, 14),
  borderRadius: 4,
  backgroundColor: theme.palette.searchButtonBg,
  color: theme.palette.white,
  fontSize: 14,
  whiteSpace: "nowrap",
}));

export const FileName = styled("span")(({ theme, isEmpty }) => ({
  flex: 1,
  minWidth: 0,
  fontSize: 14,
  color: isEmpty ? theme.palette.input.labelText : "#333",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

export const Hint = styled("div")(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.input.labelText,
  marginTop: 4,
  paddingLeft: 15,
}));

export const Error = styled("div")(({ theme }) => ({
  color: theme.palette.input.errorText,
  fontSize: 14,
  marginTop: 4,
  fontWeight: 500,

  [theme.down("sm")]: {
    fontSize: 13,
  },
}));
